module.exports = __webpack_public_path__ + "static/img/4.fa193c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/4.jpg
// module id = kWq0
// module chunks = 1